/*
 * @Descripttion: 
 * @version: 
 * @Author: 俊涛
 * @LastEditTime: 2020-05-11 19:23:29
 */
import { copy } from 'common/js/util'

export const menuListAll = state => state.menuListAll  // 菜单列表
export const isLogin = state => state.isLogin  // 登录状态
export const tabsList = state => copy(state.tabsList)  // tab标签
export const breadNameList = state => copy(state.breadNameList)  // 面包屑导航
export const defaultTheme = state => state.defaultTheme  // 主题色
export const activeMenu = state => state.activeMenu  // 选中菜单项
export const addressList = state => state.addressList  // 地址列表
export const activeMenuList = state => state.activeMenuList  // 常用菜单
export const contentSrc = state => state.contentSrc // contentSrc
// 数据词典
export const orgTypeList = state => state.orgTypeList  // 组织类型查询 【10-小区,11-社区,12-街道】
export const orgSubTypeList = state => state.orgSubTypeList  // 组织子类型查询 【D-部门,F-楼层楼宇结构,N-默认】
export const positionType = state => state.positionType  //轮播图位置获取 【01-首页顶部,02-首页中部,03-我的顶部】
export const visitedScopeType = state => state.visitedScopeType  // 可见范围获取【01-所有人员,02-小区人员,03-小区业主】
export const visitedScopeTypeTwo = state => state.visitedScopeTypeTwo  // 可见范围获取-swiper 【01-所有人员,02-小区人员,03-小区业主】
export const publishStatus = state => state.publishStatus  // 上架状态获取 【01-上架,02-下架】
export const advertiseType = state => state.advertiseType   // 公告类型获取
export const moduleJsonType = state => state.moduleJsonType  // 权限--模块类型获取 【module-模块,menu-菜单,page-页面,operation-操作】
export const moduleSubJsonType = state => state.moduleSubJsonType  // 权限--模块类型获取 【add-新增,del-删除,mod-修改,list-列表,detail-详情,imp-导入,exp-导出,status-状态】
export const userIdJsonType = state => state.userIdJsonType  // 权限--证件类型获取 【1-身份证】
export const userSexyJsonType = state => state.userSexyJsonType  // 权限--性别获取 【1-男,2-女,N-保密】
export const moduleTypeList = state => state.moduleTypeList  // 模块分类  【00-应用,01-菜单】





// WEBPACK FOOTER //
// ./src/store/getters.js